import { Link, useParams } from "react-router";
import { RouteEnum } from "../../../../common/enums/RouteEnum";
import { Button, TagGroup } from "@hatch-digital-nl/abs-storybook/legacy";
import { History } from "../../../../common/svg/History";
import { useGetQualificationByIdQuery } from "../../../../common/api/qualification";
import Skeleton from "react-loading-skeleton";
import { InfiniteImage } from "../../../../common/svg/InfiniteImage";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import {
    setIsAtQualification,
    setIsCreateCertificateModalOpen,
    setSelectedQualification,
} from "../../../../modals/CreateCertificateModal/CreateCertificateModalSlice";
import { EmployeeHeaderTag } from "./EmployeeHeaderTag";
import {
    setIsFunctionGroupModalOpen,
    setIsQualificationStandardModalOpen,
} from "../../QualificationDetailSlice";
import React, { JSX } from "react";
import { getValidityPeriodDisplay } from "../../../../common/utils/getValidityPeriodDisplay";
import { ValidityPeriodIconEnum } from "../../../../common/enums/ValidityPeriodIconEnum";

export const EmployeeQualificationDetailHeader = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const qualificationId = Number(useParams().qualificationId);
    const functionGroupModalRef = React.useRef<HTMLDivElement>(null);
    const qualificationStandardModalRef = React.useRef<HTMLDivElement>(null);
    const { isFunctionGroupModalOpen, isQualificationStandardModalOpen } =
        useAppSelector((state) => state.qualificationDetail);
    const {
        data: qualificationData,
        isLoading: qualificationIsLoading,
        isFetching: qualifcationIsFetching,
    } = useGetQualificationByIdQuery({ id: qualificationId });

    return (
        <div
            className="p-qualification-detail__header"
            style={{ backgroundImage: `url(${qualificationData?.image_url})` }}
        >
            {qualificationIsLoading || qualifcationIsFetching ? (
                <Skeleton height={"24rem"} borderRadius={"1.5rem"} />
            ) : (
                <>
                    <div className="c-breadcrumbs c-breadcrumbs--white c-breadcrumbs--border-light">
                        <span>
                            Dashboards /{" "}
                            <Link to={RouteEnum.DASHBOARD}>LMS</Link> /{" "}
                            <Link to={RouteEnum.QUALIFICATIONS}>
                                Kwalificaties
                            </Link>{" "}
                            / {qualificationData?.name}
                        </span>
                    </div>
                    <div
                        className={
                            "p-qualification-detail__header__content p-qualification-detail__header__content--employee"
                        }
                    >
                        <div
                            className={
                                "p-qualification-detail__header__content--top"
                            }
                        >
                            <EmployeeHeaderTag
                                qualificationData={qualificationData}
                            />
                            <h1>{qualificationData?.name}</h1>
                        </div>
                        <div
                            className={
                                "p-qualification-detail__header__content--bottom"
                            }
                        >
                            <div>
                                {qualificationData?.function_group &&
                                    qualificationData?.function_group?.length >
                                        0 && (
                                        <TagGroup
                                            tags={qualificationData?.function_group.map(
                                                (tag) => ({
                                                    id: tag.id,
                                                    name: tag.name,
                                                }),
                                            )}
                                            tagColor="#1D2D58"
                                            tagBackgroundColor="#DAEBA8"
                                            isOpen={isFunctionGroupModalOpen}
                                            handleClick={() =>
                                                dispatch(
                                                    setIsFunctionGroupModalOpen(
                                                        !isFunctionGroupModalOpen,
                                                    ),
                                                )
                                            }
                                            modalRef={functionGroupModalRef}
                                        />
                                    )}
                                {qualificationData?.qualification_standards &&
                                    qualificationData?.qualification_standards
                                        ?.length > 0 && (
                                        <TagGroup
                                            tags={qualificationData?.qualification_standards.map(
                                                (tag) => ({
                                                    id: tag.id,
                                                    name: tag.tag,
                                                }),
                                            )}
                                            tagColor="#FFFFFF"
                                            tagBackgroundColor="#07A9D6"
                                            isOpen={
                                                isQualificationStandardModalOpen
                                            }
                                            handleClick={() =>
                                                dispatch(
                                                    setIsQualificationStandardModalOpen(
                                                        !isQualificationStandardModalOpen,
                                                    ),
                                                )
                                            }
                                            modalRef={
                                                qualificationStandardModalRef
                                            }
                                        />
                                    )}
                                {qualificationData &&
                                    (() => {
                                        const validityPeriod =
                                            getValidityPeriodDisplay({
                                                validityPeriod:
                                                    qualificationData.validity_period,
                                                validityType:
                                                    qualificationData.validity_type,
                                                fixedValidUntil:
                                                    qualificationData.fixed_valid_until,
                                            });

                                        return (
                                            <div>
                                                {validityPeriod.icon ===
                                                ValidityPeriodIconEnum.INFINITE ? (
                                                    <InfiniteImage />
                                                ) : (
                                                    <History />
                                                )}
                                                <p>{validityPeriod.text}</p>
                                            </div>
                                        );
                                    })()}
                            </div>
                            <Button
                                variant={"primary"}
                                onClick={() => {
                                    dispatch(setIsAtQualification(true));
                                    dispatch(
                                        setSelectedQualification(
                                            qualificationData,
                                        ),
                                    );
                                    dispatch(
                                        setIsCreateCertificateModalOpen(true),
                                    );
                                }}
                            >
                                + Certificaat toevoegen
                            </Button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};
